/**
 * ClaimFormModal — wraps the shared FormModal with the claim field
 * schema. `risk_ids` multi-select pulls from the Step 6 risk list.
 */
import React, { useMemo } from 'react';
import FormModal from '../../../../components/ui/FormModal/FormModal';
import { CLAIM_FORM_FIELDS, type ClaimRecord } from './claimsFieldSchema';

const FormModalAny = FormModal as unknown as React.ComponentType<any>;

export interface OptionLite {
  value: string;
  label: string;
}

export interface ClaimFormModalProps {
  mode: 'add' | 'edit';
  initialClaim?: ClaimRecord | null;
  riskOptions: OptionLite[];
  onSubmit: (values: Record<string, unknown>) => Promise<void>;
  onClose: () => void;
}

export default function ClaimFormModal({
  mode,
  initialClaim,
  riskOptions,
  onSubmit,
  onClose,
}: ClaimFormModalProps) {
  const isEdit = mode === 'edit';

  const fields = useMemo(
    () =>
      CLAIM_FORM_FIELDS.map((f) => {
        if (f.name === 'risk_ids') return { ...f, options: riskOptions };
        if (isEdit && f.name === 'claim_id') return { ...f, disabled: true };
        return f;
      }),
    [riskOptions, isEdit],
  );

  return (
    <FormModalAny
      title={isEdit ? 'Edit Cybersecurity Claim' : 'Add Cybersecurity Claim'}
      fields={fields}
      initialValues={initialClaim ?? {}}
      submitLabel={isEdit ? 'Save Changes' : 'Add Claim'}
      submittingLabel={isEdit ? 'Saving…' : 'Adding…'}
      onSubmit={onSubmit}
      onClose={onClose}
      maxWidth={680}
    />
  );
}
